import * as Resource from './Resource';
import { Currency, DateUtils } from 'core/utils';

const DEFAULT_LANGUAGE = 'es';

let defaultLanguageCode = DEFAULT_LANGUAGE;
let languageCode = defaultLanguageCode;


const formatMoney = (value: any) =>
	typeof Intl !== 'undefined' && Intl.NumberFormat
		? Intl.NumberFormat(languageCode, { style: 'currency', currency: Currency.ISOCODE }).format(value)
		: value.toFixed(Currency.DECIMAL_PLACES) + ' ' + Currency.SYMBOL;

const toDecimal = (value: any, decimalPlaces: number) =>
	typeof Intl !== 'undefined' && Intl.NumberFormat
		? Intl.NumberFormat(languageCode, { useGrouping: true, minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces }).format(value)
		: value.toFixed(decimalPlaces);


const formatValue = function (value: any, format: string) {


	// TODO: ¿Cómo obtenemos el símbolo de moneda y el número de decimales?
	if (format.toLowerCase() === 'c') {
		return formatMoney(value);
	}

	if (format.indexOf('dd') !== -1 ||
		format.indexOf('MM') !== -1 ||
		format.indexOf('yy') !== -1 ||
		format.indexOf('HH') !== -1 ||
		format.indexOf('mm') !== -1 ||
		format.indexOf('ss') !== -1)
		return DateUtils.formatDate(value, format);

	const numericFormats = /F(\d+)/g.exec(format);
	if (numericFormats && numericFormats.length > 0)
		return toDecimal(value, parseInt(numericFormats[numericFormats.length - 1]));

	const spaceFormats = /(\d+)/g.exec(format);
	if (spaceFormats && spaceFormats.length > 0)
		return value.padStart(spaceFormats[spaceFormats.length - 1], ' ');

	return value;
};

export function text(value: string, ...params: any[]) {

	let text = Resource.get(languageCode, value) || Resource.get(DEFAULT_LANGUAGE, value);

	if (!text) {
		throw 'El recurso no existe por lo que no se puede localizar: ' + value;
	}

	if (params.length > 0) {
		// La idea es capturar la posición (\d+) y, opcionalmente, el formato, que está
		// compuesto por todo lo que haya a partir de los dos puntos y que NO sea un }.
		// Al marcar explícitamente que el formato no puee contener }, evitar el problema
		// de que haga el match con el último } de la cadena.
		text = text.replace(/{(\d+)(:([^}]+))?}/g, function (_match: string, position: number, _ignore: boolean, format: string) {
			const value = params[position];
			return format ? formatValue(value, format) : value;
		});

		// Remplazo todo lo que sea de la forma {0,X} para poner espacios
		text = text.replace(/{(\d+)(,([^}]+))?}/g, function (_match: string, position: number, _ignore: boolean, format: string) {
			const value = params[position];
			return format ? formatValue(value, format) : value;
		});

	}
	return text;
}

export function setDefaultLanguageCode(value: string) {
	if (!value) {
		throw 'New languageCode cannot be empty';
	}

	defaultLanguageCode = value;
}

export async function resetLanguageCode(onLanguageChanged: (languageCode: string) => Promise<void>) {
	if (languageCode !== defaultLanguageCode) {
		languageCode = defaultLanguageCode;
		await onLanguageChanged(languageCode);
	}
}

export async function setLanguageCode(value: string, onLanguageChanged: (languageCode: string) => Promise<void>) {

	if (!value) {
		throw 'New languageCode cannot be empty';
	}

	if (value !== languageCode) {
		languageCode = value;
		await onLanguageChanged(languageCode);
	}
}

export function getLanguageCode(): string {
	return languageCode;
}
